import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { GetQuestionSectionsQuery } from '../gql/graphql';

export function getQuestionSections(data: GetQuestionSectionsQuery) {
  if (!data || !data.questionSections || !data.questionSections.edges) {
    return [];
  }

  return data.questionSections.edges.map(
    (edge: GetQuestionSectionsQuery['questionSections']['edges'][0]) => {
      const node = edge.node;
      return {
        value: node?.uuid || '',
        label: node?.name || '',
      };
    }
  );
}

export const GET_QUESTION_SECTIONS = gql`
  query getQuestionSections($submission_uuid: String!) {
    questionSections(submissionUuid: $submission_uuid) {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`;

export function useGetQuestionSectionsQuery({
  submission_uuid,
}: {
  submission_uuid?: string;
}) {
  const { loading, error, data } = useQuery(GET_QUESTION_SECTIONS, {
    variables: {
      submission_uuid: submission_uuid || '',
    },
    skip: !submission_uuid,
    fetchPolicy: 'cache-and-network',
  });

  const questionSections = useMemo(() => getQuestionSections(data), [data]);

  return {
    loading,
    error,
    data,
    questionSections,
  };
}
